import { render, staticRenderFns } from "./RolePermissionsComponents.vue?vue&type=template&id=fe4d6b9a"
import script from "./RolePermissionsComponents.vue?vue&type=script&lang=js"
export * from "./RolePermissionsComponents.vue?vue&type=script&lang=js"
import style0 from "./RolePermissionsComponents.vue?vue&type=style&index=0&id=fe4d6b9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports